import React, { useState, useEffect } from 'react'
import BackLogo from '../../../../../../images/rewampimages/Chevron.png'
import { paginationFuction } from '../../CommonUtils';
import moment from 'moment';
import { GetHubTrackingAllByData, DownloadHubTargetReportExcelByData } from '../ActionCreator';
import Loader from '../../../../../presentationals/Loader/Loader.component'

const size = 10;


export default function List({ handleTabchange, ListData, handleTab }) {

    const [loader, setLoader] = useState(false)

    const [apiData, setapiData] = useState([])
    const [pageNumber, setPageNumber] = useState(0)
    const [totalCount, setTotalCount] = useState(1)
    const [statuses, setStatuses] = useState("ACHIEVED")


    const paginationHandlerNew = (type, pageNo) => {
        paginationFuction(type, pageNo, totalCount, callBack => {
            setPageNumber(callBack)
            GetHubTrackingAllByDataFn(callBack, statuses)
        })
    }



    const GetHubTrackingAllByDataFn = (page, status) => {
        setLoader(true)
        const data = {
            hubId: ListData?.hubId,
            status: status,
            page: page,
            size: size,
        }
        GetHubTrackingAllByData(data, callback => {
            setLoader(false)
            console.log("call", callback)
            setapiData(callback?.data?.targets || [])
            setTotalCount(callback?.data?.totalElements)
            // setTotalCount(100)
        })
    }

    useEffect(() => {
        GetHubTrackingAllByDataFn(pageNumber, statuses)
    }, [])


    const handleStatuses = (type) => {
        setStatuses(type)
        setPageNumber(0)
        GetHubTrackingAllByDataFn(0, type)
    }

    const handleDownloadList = (data) => {
        setLoader(true)
        const start = moment(data?.startDate).format("DD-MM-YYYY")
        const end = moment(data?.endDate).format("DD-MM-YYYY")
        DownloadHubTargetReportExcelByData(ListData?.hubId,start,end,callback=>{
            setLoader(false)
        })
    }

    return (
        <>
            {loader ? <Loader /> : ""}
            <div className="container-fluid">
                <div className='' style={{ marginTop: '10px', marginBottom: window.innerWidth > 1800 ? '100px' : '10px', display: 'inline-flex', alignItems: 'center' }} onClick={(e) => handleTabchange("list", '')}>
                    <img src={BackLogo} alt="" width={'8%'} style={{ marginRight: '10px', cursor: 'pointer' }} />
                    <div>
                        <h4 style={{ cursor: 'pointer', whiteSpace: 'nowrap', margin: '0', fontSize: '18px' }}>{ListData?.hubName}</h4>
                        <h5 style={{ color: 'grey', margin: '5px 0 0 0', fontSize: '12px' }}>{ListData?.address}</h5>
                    </div>
                </div>

                <div className='communitySection' style={{ marginTop: '20px' }}>
                    <div className="container-fluid">
                        <div className="row">

                            <div className="col-sm-3 col-xs-12 mt-1" >
                                <div className='details-new' style={{ marginTop: '22px' }}>
                                    <div className='btn-group btn-grp-own' role='group' aria-label='onboard-btn'>
                                        <button className={`btn btn-outline-primary`} style={{ width: 'calc(100%/3)', background: statuses == "ACHIEVED" ? "rgb(6, 66, 84)" : "rgb(241, 247, 255)", color: statuses == "ACHIEVED" ? "#fff" : "#000" }} onClick={() => handleStatuses("ACHIEVED")}>Achieved</button>
                                        <button className={`btn btn-outline-primary`} style={{ width: 'calc(100%/3)', background: statuses == "ONGOING" ? "rgb(6, 66, 84)" : "rgb(241, 247, 255)", color: statuses == "ONGOING" ? "#fff" : "#000" }} onClick={() => handleStatuses("ONGOING")}>Ongoing</button>
                                        <button className={`btn btn-outline-primary`} style={{ width: 'calc(100%/3)', background: statuses == "UPCOMING" ? "rgb(6, 66, 84)" : "rgb(241, 247, 255)", color: statuses == "UPCOMING" ? "#fff" : "#000" }} onClick={() => handleStatuses("UPCOMING")}>Upcoming</button>
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-2 col-xs-12 mt-1' >
                                <div className='btn-group' style={{ marginTop: '22px' }}>
                                    <button
                                        className='cred-btn center-block'
                                        onClick={(e) => handleTab('add', "")}
                                        style={{ padding: '11px 12px', background: '#064254' }}><i style={{ fontSize: '20px' }} className='fa fa-plus' /></button>
                                    {/* <button
                                        className='cred-btn center-block'
                                        onClick={(e) => handleDownloadList()}
                                        style={{ padding: '11px 12px', background: '#064254' }}><i style={{ fontSize: '20px' }} className='fa fa-download' /></button> */}
                                </div>
                            </div>

                            <div className="col-xs-12" style={{ marginTop: '40px' }}>
                                <div className='table-responsive full-height'>
                                    {apiData?.length > 0 ?
                                        <>
                                            <div style={{ overflowX: 'auto' }}>
                                                <table className='table credhub-table'>
                                                    <thead>

                                                        <tr>
                                                            <th scope="col">Target Month</th>
                                                            <th scope="col">L2 Target</th>
                                                            <th scope="col">L3 Target</th>
                                                            <th scope="col">L5 Target</th>
                                                            <th scope="col">Battery Target</th>
                                                            <th scope="col">Total Target</th>
                                                            {
                                                                statuses !== "UPCOMING" ?
                                                                    <>
                                                                        <th scope="col">L2 Achieved</th>
                                                                        <th scope="col">L3 Achieved</th>
                                                                        <th scope="col">L5 Achieved</th>
                                                                        <th scope="col">Battery Achieved</th>
                                                                        <th scope="col">Total Achieved</th>
                                                                        <th scope="col">Achieved %</th>
                                                                    </>
                                                                    : ""}
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Action</th>

                                                        </tr>

                                                    </thead>
                                                    <tbody>
                                                        {apiData?.map((row, i) => {
                                                            return (

                                                                <tr key={i}>

                                                                    <td>{row?.targetMonth}</td>
                                                                    <td>{row?.l2Target}</td>
                                                                    <td>{row?.l3Target}</td>
                                                                    <td>{row?.l5Target}</td>
                                                                    <td>{row?.batteryTarget}</td>
                                                                    <td>{row?.totalTarget} </td>
                                                                    {
                                                                        statuses !== "UPCOMING" ?
                                                                            <>
                                                                                <td>{row?.l2Achieved} </td>
                                                                                <td>{row?.l3Achieved} </td>
                                                                                <td>{row?.l5Achieved} </td>
                                                                                <td>{row?.batteryAchieved} </td>
                                                                                <td>{row?.totalAchieved} </td>
                                                                                <td>{row?.achievementPercentage} </td>
                                                                            </>
                                                                            : ""}
                                                                    <td>{row?.status} </td>
                                                                    <td>
                                                                        <button onClick={(e) => handleDownloadList(row)}><i className='fa fa-download'></i></button>
                                                                    </td>

                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <CustomPagination
                                                paginationHandlerNew={paginationHandlerNew}
                                                totalCount={totalCount}
                                                pageNumber={pageNumber}
                                                initalPageNo={0}
                                            />
                                        </>
                                        : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


const CustomPagination = ({ totalCount, pageNumber, paginationHandlerNew, initalPageNo }) => {
    return (
        <>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-sm-4 col-xs-12 paginationBtn' onClick={() => paginationHandlerNew('main-left', pageNumber)}>
                        <button className='' style={{ width: '100%', color: '#fff' }} >
                            <i className='fa fa-angle-double-left'></i>
                        </button>
                    </div>
                    <div className='col-sm-1 col-xs-12 paginationBtn-small' onClick={() => paginationHandlerNew('left', pageNumber)}>
                        <button className='' style={{ width: '100%', color: '#fff' }}>
                            <i className='fa fa-angle-left'></i>
                        </button>
                    </div>
                    <div className='col-sm-2 col-xs-12 text-center'>
                        <div className=''>
                            <div> Page Number : {initalPageNo == 0 ? pageNumber + 1 : pageNumber}</div>

                            <div> Total Counts :{totalCount}</div>
                        </div>
                    </div>
                    <div className='col-sm-1 col-xs-12 paginationBtn-small' onClick={() => paginationHandlerNew('right', pageNumber)}>
                        <div>
                            <button className='' style={{ width: '100%', color: '#fff' }}>
                                <i className='fa fa-angle-right'></i>
                            </button>
                        </div>
                    </div>
                    <div className='col-sm-4 col-xs-12 paginationBtn' onClick={() => paginationHandlerNew('main-right', pageNumber)}>
                        <button className='' style={{ width: '100%', color: '#fff' }} >
                            <i className='fa fa-angle-double-right'></i>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}